/**
 * This is a simple singleton service that is used as a helper to prevent
 * transitions of hoverable tooltips if another tooltip was hovered recently (1 sec)
 * TOOLTIP_GROUP_DELAY is the delay in ms triggered after mouse leave on a tooltip group,
 * allowing instantaneous display of tooltip while setTimeout within the service has not been triggered.
 */
const TOOLTIP_GROUP_DELAY = 1000;
let _preventTransition = false;
let timeoutRef;
const Service = {
    get preventTransition() {
        return _preventTransition;
    },
    setTooltipGroupTimer: function () {
        clearTimeout(timeoutRef);
        _preventTransition = true;
        timeoutRef = window.setTimeout(() => {
            _preventTransition = false;
        }, TOOLTIP_GROUP_DELAY);
    },
};
export default Service;
export const HOVER_DELAY = 300;
export const SCREEN_EDGE_THRESHOLD = 20;
export const LEFT_POSITION_DEFAULT = '50%';
export const LEFT_POSITION_DEFAULT_RTL = '0%';
export const POSITIONS = {
    TOP: 'top',
    TRAILING: 'trailing',
    BOTTOM: 'bottom',
    LEADING: 'leading',
};
// Extended version of document.getElementById. This function traverses shadowDom chain to the document root.
function findElementWithId(domRoot, elementId) {
    if (domRoot.getElementById) {
        const result = domRoot.getElementById(elementId);
        if (result)
            return result;
        else if (domRoot.nodeType === 11 && domRoot.host) {
            // shadowDom
            return findElementWithId(domRoot.host.getRootNode(), elementId);
        }
    }
}
export function resolveOverflow(tooltipElement, tooltipBodyElement, boundaryElementID) {
    const boundaryElement = boundaryElementID
        ? findElementWithId(tooltipElement.getRootNode(), boundaryElementID)
        : undefined;
    if (!window || !tooltipElement || !tooltipBodyElement)
        return;
    const innerWidth = window.innerWidth * 0.01;
    const triggerWrapper = tooltipElement.getBoundingClientRect();
    tooltipBodyElement.style.setProperty('--skapa-trigger-left', `${(triggerWrapper.left / innerWidth).toFixed(0)}vw`);
    tooltipBodyElement.style.setProperty('--skapa-trigger-right', `${(triggerWrapper.right / innerWidth).toFixed(0)}vw`);
    if (boundaryElement) {
        const bounds = boundaryElement.getBoundingClientRect();
        tooltipBodyElement.style.setProperty('--skapa-tooltip-boundary-left', `${(bounds.left / innerWidth).toFixed(0)}vw`);
        tooltipBodyElement.style.setProperty('--skapa-tooltip-boundary-right', `${(bounds.right / innerWidth).toFixed(0)}vw`);
    }
    else {
        // perhaps not needed every time, only if the property has been updated.
        tooltipBodyElement.style.removeProperty('--skapa-tooltip-boundary-left');
        tooltipBodyElement.style.removeProperty('--skapa-tooltip-boundary-right');
    }
}
